import { Box, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  icon?: React.ReactNode;
  header: string;
  title?: string;
  actions?: React.ReactNode;
}

export const IntegrationStatus: React.FC<IProps> = ({ icon, header, title, actions }) => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1,
        transform: 'translateY(-8%)',
        px: 2,
      }}
    >
      <>
        {icon}
        <Typography variant="h6">{header}</Typography>
        <Typography variant="body1" color="text.secondary">
          {title}
        </Typography>
        {actions && <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>{actions}</Box>}
      </>
    </Box>
  );
};
